<template>
  <modal
    background-mode
    class="cookies-modal"
    :visible="isShown"
    @on-close="isShown = false"
  >
    <div class="cookies-modal__content">
      <div class="cookies-modal__text">
        Мы используем файлы cookie и другие технологии для анализа использования наших товаров и
        услуг и повышения качества рекомендаций.
        Нажимая на кнопку «Да, согласен», вы даете согласие на обработку своих персональных данных в
        соответствии с <a target="_blank" href="/agreement">пользовательским соглашением.</a>
      </div>

      <ui-button
        class="cookies-modal__button"
        text="Да, согласен"
        @click.stop="setCookie"
      />
    </div>
  </modal>
</template>

<script>
import {setCookieAgreement, getCookieAgreement} from '@/utils/agreement-cookies';

export default {
  name: 'cookies-modal',

  data() {
    return {
      shownCookiesModal: false
    }
  },

  computed: {
    isShown: {
      get() {
        return this.shownCookiesModal && !getCookieAgreement();
      },

      set(val) {
        this.shownCookiesModal = val;
      }
    }
  },

  mounted() {
    // без этой инициализации будет мелькать при загрузке
    this.shownCookiesModal = !getCookieAgreement();
  },

  methods: {
    setCookie() {
      setCookieAgreement();
      this.isShown = false;
    },
  }
};
</script>

<style lang="scss">
div.cookies-modal {
  top: auto;
  background: transparent;
  box-shadow: 0 4px 32px rgba(0, 0, 0, .16);

  .modal-content {
    position: relative;
    max-height: 100%;
  }

  &__text {
    font-size: 14px;
    line-height: 20px;
    color: $gray;

    a {
      color: $black;
    }
  }

  .ui-button {
    margin: 24px 0 0;
    width: 100%;
  }
}

@include breakpoint("tablet") {
  div.cookies-modal {

    .modal-content {
      height: 100%;
      padding: 20px 68px 26px;
    }

    &__content {
      display: flex;
      align-items: flex-start;
    }

    &__text {
      font-size: 16px;
      line-height: 24px;
    }

    .ui-button {
      width: 119px;
      min-width: 119px;
      margin: 0 0 0 18px;
    }
  }
}

@include breakpoint("desktop") {
  div.cookies-modal {

    .modal-content {
      max-width: 1440px;
      padding: 20px 108px;
    }

    .ui-button {
      margin: 0 0 0 165px;
    }
  }
}
</style>